module.exports = __webpack_public_path__ + "img/grey.246a1fd8.jpg";